<div class="selection-dialog p-4 position-relative">
  <button mat-icon-button class="close-btn" (click)="logoutAndClose()" matTooltip="Close & Logout">
    <mat-icon>close</mat-icon>
  </button>
  <div class="text-center pb-2">
    <h4 class="fw-bold mb-2 theme-text">{{ 'Select Your Profile' | translate }}</h4>
    <p class="mb-4 text-center select-account-label">{{ 'We found multiple profiles for this account.' |
      translate }}</p>
  </div>

  <div class="scrollable-list mb-4">
    <div class="list-group border-0">
      <div *ngFor="let option of patients" class="user-option-card d-flex align-items-center p-3 mb-3"
        (click)="selectedOption = option" [class.selected-card]="selectedOption === option">

        <div class="user-avatar mr-4">
          <div class="avatar-circle" [ngClass]="selectedOption === option ? 'avatar-selected' : 'avatar-unselected'">
            {{ option.Name ? option.Name.charAt(0).toUpperCase() : 'U' }}
          </div>
        </div>

        <div class="user-info text-start flex-grow-1 overflow-hidden">
          <h6 class="mb-1 fw-bold text-truncate" [ngClass]="selectedOption === option ? 'theme-text' : 'text-dark'"
            style="font-size: 16px;">
            {{ option.Name }}
          </h6>
          <div class="small d-flex flex-column gap-2 mt-2" style="color: #4a4a4a; font-weight: 500;">
            <span *ngIf="option.CompanyName" class="text-truncate d-flex align-items-center">
              <mat-icon class="icon-sm mr-2 ml-2" style="color: #6c757d;" matTooltip="Clinic Name">business</mat-icon>
              {{ option.CompanyName }}
            </span>
            <span *ngIf="option.email" class="text-truncate d-flex align-items-center">
              <mat-icon class="icon-sm mr-2 ml-2" style="color: #6c757d;" matTooltip="Email">email</mat-icon>
              {{ option.email }}
            </span>
            <span *ngIf="option.userName" class="text-truncate d-flex align-items-center">
              <mat-icon class="icon-sm mr-2 ml-2" style="color: #6c757d;" matTooltip="UserName">person</mat-icon>
              {{ option.userName }}
            </span>
          </div>
        </div>

        <div class="selection-indicator d-flex align-items-center ml-3">
          <mat-icon *ngIf="selectedOption === option" class="theme-text">check_circle</mat-icon>
          <mat-icon *ngIf="selectedOption !== option" style="color: #ccc;">radio_button_unchecked</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center mt-4 pt-2 border-top">
    <button class="btn btn-secondary-modern px-4 py-2 fw-bold mt-3 mr-3" *ngIf="fromLoggedInUser" (click)="close()">
      {{ 'common.CANCEL' | translate }}
    </button>

    <button class="btn theme-btn px-4 py-2 fw-bold mt-3 mr-3" (click)="selectPatient(selectedOption)"
      *ngIf="!fromLoggedInUser">
      {{ 'LOGIN' | translate }}
    </button>

    <button class="btn theme-btn px-4 py-2 fw-bold mt-3" *ngIf="fromLoggedInUser"
      (click)="selectPatient(selectedOption)">
      {{ 'admin.SwitchUser' | translate }}
    </button>
  </div>
</div>